import React from 'react';

import { formatCurrency } from 'utils/CurrencyUtils';

import { useSOTotalDetailLang } from './hooks';

import makeClasses from './SOTotalDetail.style';

interface Props {
  subtotal: number;
}

export function SOTotalDetail({ subtotal }: Props) {
  const classes = makeClasses();
  const lang = useSOTotalDetailLang();

  return (
    <div className={classes.root}>
      <p className={classes.totalLabel}>{lang.totalLabel}</p>
      <p className={classes.totalAmount}>{formatCurrency(subtotal, false)}</p>
    </div>
  );
}
